import { FolderStructureDTO } from "../DTO/folderStructureDTO";

export class FolderStructure{
    public id?:number;
    public businessId!:string;
    public clientId?:number;
    public structure!:string;
    public context?:string;
    public contextId?:number;
    public added?:Date;
    public addedByUser?:string;
    public edited?:Date;
    public lastEditedByUser?:string;

    public static mapToDTO(param:FolderStructure) : FolderStructureDTO{
        
        let dto = new FolderStructureDTO();
        try
        {
            dto.id = param.id;
            dto.businessId = param.businessId;
            dto.clientId = param.clientId;
            dto.structure = param.structure;
            dto.context = param.context;
            dto.contextId = param.contextId;
            dto.addedByUser = param.addedByUser;
            if(param.added) dto.added = param.added.toISOString();
            dto.lastEditedByUser = param.lastEditedByUser;
            if(param.edited) dto.edited = param.edited.toISOString();
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:FolderStructureDTO) : FolderStructure
    {
        
        let obj = new FolderStructure();
        try
        {
            obj.id = param.id;
            obj.businessId = param.businessId;
            obj.clientId = param.clientId;
            obj.structure = param.structure;
            obj.context = param.context;
            obj.contextId = param.contextId;
            obj.addedByUser = param.addedByUser;
            if(param.added) obj.added = new Date(param.added);
            obj.lastEditedByUser = param.lastEditedByUser;
            if(param.edited) obj.edited = new Date(param.edited);       
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

}